/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsBillingAzureAdvisor extends models.RecommendationBaseForFinOps {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsBillingAzureAdvisor");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsBillingAzureAdvisor.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsBillingAzureAdvisor>): RecommendationForFinopsBillingAzureAdvisor {
        let obj = Object.assign(new RecommendationForFinopsBillingAzureAdvisor(), model);
        RecommendationForFinopsBillingAzureAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsBillingAzureAdvisor>): RecommendationForFinopsBillingAzureAdvisor {
        if (!model) return null;
        return RecommendationForFinopsBillingAzureAdvisor.newInstance(<RecommendationForFinopsBillingAzureAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsBillingAzureAdvisor) {
        if (!obj) return;

        models.RecommendationForFinopsBillingAzureAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsBillingAzureAdvisor): boolean {
        if (models.RecommendationBaseForFinOps.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsBillingAzureAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
